import { SelectOption } from '@factorialco/deprecated-design-system'
import { PayrollCyclesDocument } from 'generated/resources/graphql'
import { useQuery } from 'modules/core/hooks/useQuery'

type UseLegalEntitiesOptionsParams = {
  companyId: string | undefined
  countryCode: string
}

const useLegalEntitiesOptions = ({ companyId, countryCode }: UseLegalEntitiesOptionsParams) => {
  const companyIds = companyId ? [companyId] : undefined

  const { data, loading } = useQuery(PayrollCyclesDocument, {
    variables: {
      companyIds,
      countryIds: [countryCode],
    },
    skip: !companyId,
  })

  const legalEntities = data?.companies.legalEntitiesConnection.nodes

  const legalEntitiesOptions: SelectOption[] =
    legalEntities?.map((legalEntity) => ({
      label: legalEntity.legalName,
      value: legalEntity.id,
    })) ?? []

  return {
    loading,
    legalEntitiesOptions,
  }
}

export default useLegalEntitiesOptions
